const accHD = document.getElementsByClassName('accordion-title');

function docReady(fn) {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

docReady(() => {
  function toggleItem() {
    const itemClass = this.parentNode.className;
    const chevron = this.parentNode.querySelector('.wp-block-twoyou-accordiontitle-chevron');
    const acContent = this.parentNode.querySelector('.accordion-content');
    this.parentNode.classList.toggle('close');
    this.parentNode.classList.toggle('open');
    if (itemClass.includes('close')) {
      chevron.setAttribute('aria-label', 'Expanded');
      this.setAttribute('aria-expanded', true);
      acContent.classList.remove('hide');
    } else {
      chevron.setAttribute('aria-label', 'Collapsed');
      this.setAttribute('aria-expanded', false);
      acContent.classList.add('hide');
    }
  }

  function hashChange() {
    // Safely get and validate the hash
    const { hash: rawHash } = window.location;
    const safeHash = rawHash.replace(/[^a-zA-Z0-9-_]/g, '');
    if (safeHash) {
      const targetElement = document.querySelector(`#${safeHash}`);
      // eslint-disable-next-line no-unused-expressions
      targetElement
        ?.closest('.wp-block-twoyou-accordionitem.close')
        ?.querySelector('.accordion-title')
        ?.click();
    }
  }

  for (let i = 0; i < accHD.length; i += 1) {
    accHD[i].addEventListener('click', toggleItem, false);
  }

  window.addEventListener('hashchange', hashChange);
  hashChange(); // Check hash on page load
});
